import { render } from "./AdminRejected75Liquidations.vue?vue&type=template&id=5d478cf3"
import script from "./AdminRejected75Liquidations.vue?vue&type=script&lang=js"
export * from "./AdminRejected75Liquidations.vue?vue&type=script&lang=js"

import "./AdminRejected75Liquidations.vue?vue&type=style&index=0&id=5d478cf3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__